import React from "react";

const CTA = () => {
  return (
    <div className="card shadow-lg compact bg-base-100">
      <div className="card-body">
        <div className="mx-3 flex items-center justify-center flex-col call-to-action-part">
          <h2>Ready to kickstart your project?</h2>
          <p className="text-center text-base-content">
            <span className="text-base-content opacity-70">
              Your Ideas, My Code, One Vision! <br />
              Looking for a developer who transforms your concepts into stunning
              experiences?
            </span>
          </p>

          <a href="mailto:jaybudhraja08@gmail.com" className="cta-button">
            <span className="cta-button__icon-wrapper">
              <svg
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cta-button__icon-svg"
                width="10"
              >
                <path
                  d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                ></path>
              </svg>

              <svg
                viewBox="0 0 14 15"
                fill="none"
                width="10"
                xmlns="http://www.w3.org/2000/svg"
                className="cta-button__icon-svg cta-button__icon-svg--copy"
              >
                <path
                  d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
            Let's Talk
          </a>
        </div>
      </div>
    </div>
  );
};

export default CTA;
